import React from "react"
import "./styles.scss"

function BottomBadges(props) {
  return (
    <section class="">
      <div class="bottomBadges">
        <div class="large-badge">
          <a
            class="appstoreBadgeBottom"
            href="https://apps.apple.com/us/app/diskmate/id1467915119?mt=12"
          ></a>
        </div>
      </div>
    </section>
  )
}

export default BottomBadges
